import { REGEX_URL_NAME } from '@/constants/constants';


export default {
  name: 'SignInSuccess',

  props: {
    successRedirectUrl: {
      type: String,
      default: '',
    },
  },

  mounted() {
    if (this.$store.getters.redirectUri) {
      this.redirectUri = this.$store.getters.redirectUri;
    }
  },

  computed: {
    redirectUriName() {
      const urlFromQuery = this.redirectUri.match(REGEX_URL_NAME)[3];
      const urlFromApi = this.successRedirectUrl.match(REGEX_URL_NAME)[3];

      return urlFromQuery || urlFromApi;
    },
  },

  methods: {
  },

  beforeDestroy() {
    clearInterval(this.localTimerId);
  },

  data() {
    return {
      redirectUri: '',
    };
  },
};
